<template>
  <div class="btn-group btn-group-sm">
    <button v-if="can_access('customer_approve','view')" class="btn" :class="row.approved_by?'btn-completed':'btn-pending'" title="Approve Customer" @click="showModal('approve')"><i class="fa fa-check-circle"></i>{{row.approved_by?'Approved':can_access('customer_approve','modify')?'Approve':'Waiting For Approve'}}</button>

    <b-modal ref="edit-customer-out" title="Add Customer" size="xl" hide-footer v-if="can_access('customer_approve','modify')">
        <p class="my-4"><AddCustomerForm :rows="rowData" :forceRerender="customerFormReRender"/></p>
      </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import AddCustomerForm from '@/components/Accounts/AddCustomerForm';
export default {
  props: ['row', 'nested','refresh'],
  components: {  AddCustomerForm },
  mixins: [common],
  data(){
    return {
      show: 1,
      rowData:{},
      action:''
    }
  },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
  },
  methods: {
    customerFormReRender(response) {
      if(response.code==0){
        this.$refs['edit-customer-out'].hide();
        this.show = 1;
        this.refresh();
        this.$toasted.success("Successfully Added",{duration:1000});
      }
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal(action) {
        this.action = action;
        if(action=='approve'){
            if(!this.row.approved_by && this.can_access('customer_approve','modify')){
                this.rowData = this.duplicate(this.row);
                this.rowData.action = 'approve'
                this.$refs['edit-customer-out'].show()
            }
        }
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
